var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgL = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.75rem",
  height: "5.75rem",
  "data-name": "Group 26",
  viewBox: "0 0 217.346 160.028"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "L_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h217.346v160.028H0z",
  "data-name": "Rectangle 27",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 25",
  style: {
    clipPath: "url(#L_svg__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "m186.391 100.029-38.435-83.865q.17-.055.351-.111a57.8 57.8 0 0 1 17.893-2.995c19.026 0 42.888 10.9 48.525 62.843a23.18 23.18 0 0 1-5.662 17.884 18.22 18.22 0 0 1-13.588 6.244z",
  "data-name": "Path 39",
  style: {
    fill: "#fff"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M166.2 10.558v5c10.707 0 19.782 3.585 26.974 10.656 10.135 9.964 16.55 26.771 19.062 49.919a20.68 20.68 0 0 1-5.026 15.976 15.76 15.76 0 0 1-11.734 5.421h-7.479L151.413 17.7a54.7 54.7 0 0 1 14.787-2.142zm0 0a60 60 0 0 0-18.638 3.109 31 31 0 0 0-3 1.081l40.229 87.782h10.687c13.089 0 23.176-12.609 21.735-26.9-5.921-54.53-31.834-65.072-51.013-65.072",
  "data-name": "Path 40"
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.883 100.048a18.31 18.31 0 0 1-13.7-6.312A22.9 22.9 0 0 1 2.64 75.948c5.6-51.983 29.513-62.893 48.584-62.893A57.7 57.7 0 0 1 69.4 16.146l-38.437 83.9z",
  "data-name": "Path 41",
  style: {
    fill: "#fff"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M51.224 15.555a54.6 54.6 0 0 1 14.721 2.128L29.357 97.548h-7.474a15.84 15.84 0 0 1-11.844-5.483 20.4 20.4 0 0 1-4.913-15.85c2.5-23.2 8.916-40.024 19.067-49.995 7.2-7.077 16.3-10.665 27.031-10.665m0-5c-19.216 0-45.188 10.552-51.07 65.125-1.536 14.257 8.586 26.868 21.729 26.868h10.683l40.218-87.79a58.5 58.5 0 0 0-21.56-4.2",
  "data-name": "Path 42"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M185.673 102.583a50.8 50.8 0 0 1-38.166 37.834c0 .165-.334.165-.5.165a48.7 48.7 0 0 1-11.166 1.334H81.506a51.3 51.3 0 0 1-11.333-1.334.83.83 0 0 1-.5-.165 51.3 51.3 0 0 1-38.167-37.834 52.2 52.2 0 0 1 0-24.334l3.668-15a82.98 82.98 0 0 1 34.5-49.5 84.8 84.8 0 0 1 28.5-12.166 26 26 0 0 1 3.832-.833l.065-.015A29.5 29.5 0 0 1 113.8.457c1.792.317 3.583.7 5.375 1.126a83.75 83.75 0 0 1 63 61.667l3.5 15a48.13 48.13 0 0 1 0 24.334",
  "data-name": "Path 43"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M153.076 126.072a20.3 20.3 0 0 1-1.346 7.481 1.45 1.45 0 0 1-.269.681s-.135 0-.135.169c-3.9 10.373-15.077 18.534-29.346 21.765a66 66 0 0 1-26.654 0c-14.269-3.231-25.443-11.392-29.346-21.768 0-.169-.135-.169-.135-.169a1.44 1.44 0 0 1-.27-.681 20.3 20.3 0 0 1-1.345-7.481c0-12.071 9.691-22.613 23.961-27.884h.269l2.828-1.021a64.54 64.54 0 0 1 34.73 0l2.827 1.021h.27c14.269 5.271 23.961 15.813 23.961 27.884",
  "data-name": "Path 44"
})), /*#__PURE__*/React.createElement("path", {
  d: "M108.653 160.028a69.5 69.5 0 0 1-13.827-1.411c-15.19-3.438-26.744-12.008-31.049-22.976a4.1 4.1 0 0 1-.628-1.43 22.9 22.9 0 0 1-1.42-8.139c0-12.814 9.808-24.4 25.595-30.229l.42-.155h.279l2.581-.926a67.05 67.05 0 0 1 36.1 0l.166.053 2.415.873h.279l.42.155c15.787 5.832 25.6 17.415 25.6 30.229a22.9 22.9 0 0 1-1.419 8.139 4.1 4.1 0 0 1-.629 1.43c-4.3 10.969-15.858 19.538-31 22.965a69.6 69.6 0 0 1-13.879 1.422M68.386 133.7c3.609 9.338 14.121 17 27.492 20.031a63.9 63.9 0 0 0 25.6-.011c13.318-3.016 23.83-10.682 27.439-20.02a2.7 2.7 0 0 1 .4-.851l.085-.213a17.8 17.8 0 0 0 1.17-6.562c0-10.559-8.385-20.255-21.914-25.384h-.255l-3.155-1.14a62.07 62.07 0 0 0-33.2 0l-3.155 1.14h-.255c-13.529 5.129-21.914 14.825-21.914 25.384a17.8 17.8 0 0 0 1.171 6.562l.084.213a2.7 2.7 0 0 1 .4.851",
  "data-name": "Path 45",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M93 75.491a2.393 2.393 0 0 1-2.4-2.391 8.385 8.385 0 0 0-16.771 0 2.394 2.394 0 0 1-4.788 0 13.174 13.174 0 0 1 26.347 0A2.393 2.393 0 0 1 93 75.491",
  "data-name": "Path 46",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.87 75.491a2.393 2.393 0 0 1-2.394-2.394 8.388 8.388 0 0 0-16.776 0 2.393 2.393 0 1 1-4.787 0 13.176 13.176 0 0 1 26.351 0 2.393 2.393 0 0 1-2.394 2.394",
  "data-name": "Path 47",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m96.8 119.969-2.907-3.733a6.6 6.6 0 0 1 5.21-10.659h19.108a6.6 6.6 0 0 1 5.21 10.659l-2.906 3.733a15.027 15.027 0 0 1-23.715 0",
  "data-name": "Path 48",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.627 138.865a14.727 14.727 0 0 1-14.711-14.711 2.673 2.673 0 0 1 5.346 0 9.362 9.362 0 1 0 18.725 0 2.673 2.673 0 0 1 5.345 0 14.725 14.725 0 0 1-14.705 14.711",
  "data-name": "Path 49",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.682 138.865a14.727 14.727 0 0 1-14.711-14.711 2.673 2.673 0 0 1 5.346 0 9.363 9.363 0 1 0 18.725 0 2.672 2.672 0 0 1 5.345 0 14.725 14.725 0 0 1-14.7 14.711",
  "data-name": "Path 50",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.644 127.344a2.67 2.67 0 0 1-2.673-2.673v-5.257a2.673 2.673 0 0 1 5.346 0v5.257a2.67 2.67 0 0 1-2.673 2.673",
  "data-name": "Path 51",
  style: {
    fill: "#fff"
  }
})));
export default SvgL;